import {
  ChangeDetectionStrategy,
  Component,
  HostAttributeToken,
  inject,
  input,
} from '@angular/core'

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class LoadingComponent {
  isFullScreen = inject(new HostAttributeToken('isFullScreen'), { optional: true })! ?? true

  readonly showBg = input(false)

  constructor() {}
}
